import { EapSettings } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import { DESCRIPTION_BASE_KEY, DescriptionResult, PREVENT_DELETE_KEY } from './use-delete-eap-setting.constants';

const getSingleSettingDescription = (eapSetting: EapSettings): DescriptionResult => {
    if (eapSetting.assignedDeviceCount === 0) {
        return {
            key: `${DESCRIPTION_BASE_KEY}.no-devices`,
            params: { name: eapSetting.name, count: 0 },
        };
    }

    const suffix = eapSetting.assignedDeviceCount === 1 ? 'one' : 'multiple';

    return {
        key: `${DESCRIPTION_BASE_KEY}.${suffix}-devices`,
        params: { name: eapSetting.name, count: eapSetting.assignedDeviceCount },
    };
};

const getMultipleSettingsDescription = (eapSettings: EapSettings[]): DescriptionResult => {
    const totalAssignedDevices = eapSettings.reduce((sum, es) => sum + es.assignedDeviceCount, 0);
    const suffix = totalAssignedDevices === 0 ? 'no-devices' : 'with-devices';

    return {
        key: `${DESCRIPTION_BASE_KEY}.multiple-settings.${suffix}`,
        params: { count: eapSettings.length, deviceCount: totalAssignedDevices },
    };
};

export const getDeleteDescriptionTranslation = (eapSettings: EapSettings[]): DescriptionResult =>
    eapSettings.length === 1
        ? getSingleSettingDescription(eapSettings[0])
        : getMultipleSettingsDescription(eapSettings);

export const hasDevicesAssigned = (eapSettings: EapSettings[]): boolean =>
    eapSettings.some((es) => es.assignedDeviceCount > 0);

export const getPreventDeleteDescriptionTranslation = (eapSettings: EapSettings[]): DescriptionResult => {
    const totalAssignedDevices = eapSettings.reduce((sum, es) => sum + es.assignedDeviceCount, 0);

    if (eapSettings.length === 1) {
        return {
            key: PREVENT_DELETE_KEY.description.one,
            params: { name: eapSettings[0].name, deviceCount: totalAssignedDevices },
        };
    }

    return {
        key: PREVENT_DELETE_KEY.description.multiple,
        params: { count: eapSettings.length, deviceCount: totalAssignedDevices },
    };
};
